import React from 'react'

import { reactular } from '@vendhq/reactular'
import { Textarea } from './LineItemTextarea'

interface Props {
  confirmed?: boolean
  note?: string
  editAllowedForConfirmed?: boolean
  onBlur?: () => void
  onChange?: (note?: string) => void
  error?: boolean
}

export const LineItemNote: React.FC<Props> = ({
  confirmed,
  note,
  editAllowedForConfirmed = false,
  onBlur,
  onChange,
  error,
}) => {
  return (
    <div>
      <div className="vd-field">
        {(editAllowedForConfirmed || !confirmed || note) && (
          <div className="vd-label">Note</div>
        )}
        <div className="vd-value">
          {confirmed && !editAllowedForConfirmed ? (
            note && <div>{note}</div>
          ) : (
            <Textarea
              spellCheck={false}
              value={note}
              name="lineItemNote"
              onBlur={onBlur}
              onChange={onChange && (event => onChange(event.target.value))}
              placeholder="Enter a note"
              className={error ? 'vd-error' : ''}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export const LineItemNoteComponent = reactular(LineItemNote, [
  'confirmed',
  'note',
  'editAllowedForConfirmed',
  'onBlur',
  'onChange',
])
